import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { CalendarMonth } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import gyrotrustLogo from '../assert/gyrotrustLogo.png';
import { Link, useNavigate } from 'react-router-dom';
import { Avatar, useMediaQuery } from "@mui/material";

function samePageLinkNavigation(event) {
  if (
    event.defaultPrevented ||
    event.button !== 0 || // ignore everything but left-click
    event.metaKey ||
    event.ctrlKey ||
    event.altKey ||
    event.shiftKey
  ) {
    return false;
  }
  return true;
}

function LinkTab(props) {
  return (
    <Tab
      component="div"
      onClick={(event) => {
        if (samePageLinkNavigation(event)) {
          event.preventDefault();
          props.onClick();
        }
      }}
      aria-current={props.selected && 'page'}
      {...props}
    />
  );
}

LinkTab.propTypes = {
  selected: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

export default function Landing() {
  const [value, setValue] = useState(0);
  const [currentTime, setCurrentTime] = useState(new Date());
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm')); // Check for small screen

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(intervalId); // Clean up the interval on component unmount
  }, []);

  const options = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: true,
  };

  const calLang = "en-US"; // Replace with Extension.languageBasedValue("en-US", "ta-US") if defined

  const handleNavigation = (path) => () => {
    navigate(path);
  };

  return (
    <Box sx={{
      width: isSmallScreen?'95.7%':'98.9%',
      backgroundColor: '#e9c426',
      color: '#000000',
      padding: '10px', // Add padding for better spacing
    }}>
      <Grid container spacing={2} alignItems="center">
        {/* Logo */}
        <Grid item xs={2} sm={3} >
          <Avatar
            src={gyrotrustLogo}
            alt="logo"
            sx={{ width: '43px', height: '43px',marginLeft:isSmallScreen?'10px':'40px'}}
          />
        </Grid>
        {/* Admission Text */}
        <Grid item xs={8} sm={5}>
          <div style={{ fontSize: '20px', textAlign: isSmallScreen ? 'left' : 'center', whiteSpace: 'nowrap',left:isSmallScreen?-10:10, marginLeft:isSmallScreen?0:'100px',top:2 }}>
            Engineering Admission Helper
          </div>
        </Grid>
        {/* Timer */}
        {!isSmallScreen && (
          <Grid item xs={12} sm={4}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', marginBottom: 5,marginLeft:'200px' }}>
              <CalendarMonth />
              <div style={{ marginLeft: '5px' }}>{currentTime.toLocaleTimeString(calLang, options)}</div>
            </div>
          </Grid>
        )}
      </Grid>
    </Box>
  );
}
